import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { LAYOUT_BOX, LAYOUT_HEADER, LAYOUT_SPLASH } from 'config/constants/ui'
import gns3Theme from 'config/constants/themeDefaults/gns3'
import layoutBoxConstants from 'config/constants/themeDefaults/layoutBox'
import layoutHeaderConstants from 'config/constants/themeDefaults/layoutHeader'
import layoutSplashConstants from 'config/constants/themeDefaults/layoutSplash'
import motherWebsiteTheme from 'config/constants/themeDefaults/motherWebsite'
import { useOrganization } from 'src/core/graphql/hooks'
import { useGlobalState } from 'src/sites/state'
import HUDMenu from '~/components/HUDMenu'
import BoxLayout from '~/components/Layout/Box'
import HeaderLayout from '~/components/Layout/Header'
import SplashLayout from '~/components/Layout/Splash'

const customThemes = {
   gns3: gns3Theme,
   'mother-website': motherWebsiteTheme
}

const layouts = {
   [LAYOUT_BOX]: {
      component: BoxLayout,
      constants: layoutBoxConstants
   },
   [LAYOUT_HEADER]: {
      component: HeaderLayout,
      constants: layoutHeaderConstants
   },
   [LAYOUT_SPLASH]: {
      component: SplashLayout,
      constants: layoutSplashConstants
   }
}

const GlobalLayout = ({ children }) => {
   const location = useLocation()
   const { theme, setTheme } = useGlobalState()
   const currentLayout = theme.tmpGlobalLayout
   const LayoutComponent = layouts[currentLayout].component

   const { organization } = useOrganization()
   const isBleedingEdge = organization?.gatherAppVersion === 6 ||
      process.env.NODE_ENV === 'development'

   // Set theme constants for current layout
   useEffect(() => {
      const customTheme = customThemes[organization.slug] || {}

      setTheme({
         ...theme,
         ...layouts[currentLayout].constants,
         ...customTheme
      })
   }, [currentLayout])

   useEffect(() => {
      document.body.style.background = theme.tmpBackgroundColor
   }, [theme.tmpBackgroundColor])

   // TODO: Change how this works
   // For the following routes, render without Layout Container
   // as they are standalone views or takeover the screen
   // PR #757
   if (location.pathname.startsWith('/account') ||
      location.pathname.startsWith('/-/invitation') ||
      location.pathname.startsWith('/-/start')) {
      return children
   }

   return (
      <>
         <LayoutComponent>
            {children}
         </LayoutComponent>
         {isBleedingEdge && <HUDMenu />}
      </>
   )
}

GlobalLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default GlobalLayout
